<template>
  <router-view
    v-if="instance"
    :instance="instance"
    class="wrapper"
  />

  <div v-else-if="instances.length === 0" class="wrapper dashboard">
    <div class="start">
      <el-card class="apps">
        <h2>Welcome to Runstack, let's get started</h2>

        <p>Looks like you don't have any Cloud Servers.</p>
        <p>Start deploying a CMS or an application with the language of your choice.<br>
          Runstack will help you choosing the best Cloud Server configuration.</p>

        <el-divider />

        <el-button class="app wordpress" type="default" @click="$router.push('/create/wordpress')">
          Create a Wordpress site
        </el-button>

        <el-button class="app laravel" type="default" @click="$router.push('/create/laravel')">
          Create a Laravel project
        </el-button>

        <el-button class="app php" type="default" @click="$router.push('/create/php')">
          Create a PHP project
        </el-button>
      </el-card>
    </div>
  </div>

  <div v-else class="wrapper has-tips">
    <h2>
      Cloud Servers
      <el-button type="primary" @click="$router.push('/create')">Create Cloud Server</el-button>
    </h2>

    <el-table
      id="instances-list"
      :data="instances"
      :default-sort="defaultSort"
      size="small"
    >
      <el-table-column width="38px" align="center">
        <template slot-scope="scope">
          <i v-if="scope.row.state !== 'running'" class="el-icon-loading" />
          <img
            v-else
            :src="regionFlag(scope.row.planId)"
            class="flag"
            @click="$router.push('/instances/' + scope.row.id)"
          />
        </template>
      </el-table-column>

      <el-table-column label="Name" prop="name" sortable>
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="$router.push('/instances/' + scope.row.id)"
          >
            {{ scope.row.name }}
          </el-button>
        </template>
      </el-table-column>

      <el-table-column
        label="IP Address"
        prop="publicIp"
        min-width="100px"
        show-overflow-tooltip
        sortable
      >
        <template v-if="scope.row.publicIp" slot-scope="scope">
          <Clipboard :value="scope.row.publicIp" :id="scope.row.id" />
          ({{ regionName(scope.row.planId) }})
        </template>
      </el-table-column>

      <el-table-column label="Provider" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ planProvider(scope.row.planId) }}
        </template>
      </el-table-column>

      <el-table-column label="Configuration" show-overflow-tooltip>
        <template slot-scope="scope">
          {{ planDescription(scope.row.planId, true) }}
        </template>
      </el-table-column>

      <el-table-column label="Created" prop="created" width="195px" sortable>
        <template slot-scope="scope">
          {{ toCalendar(scope.row.created) }}
        </template>
      </el-table-column>

      <el-table-column label="Applications" min-width="140px" show-overflow-tooltip>
        <template slot-scope="scope">
          <InstanceState
            v-if="scope.row.state !== 'running'"
            :instance="scope.row"
            size="small"
          />

          <template v-else>
            <ApplicationScreen
              v-for="application in getApplications(scope.row.id)"
              :key="application.id"
              :application="application"
              @click="$router.push('/instances/' + scope.row.id + '/' + application.id)"
            />
          </template>
        </template>
      </el-table-column>
    </el-table>

    <Pagination v-if="false" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Pagination from '../components/Pagination'
import InstanceState from '../components/Instance/State'
import Clipboard from '../components/Clipboard'
import ApplicationScreen from '../components/Application/Screen'

export default {
  components: {
    Pagination,
    InstanceState,
    Clipboard,
    ApplicationScreen
  },
  data () {
    return {
      create: false,
      defaultSort: {
        prop: 'created',
        order: 'descending'
      }
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
    instance () {
      return this.instances.find((i) => i.id === this.$route.params.id)
    },
    ...mapState(['instances', 'applications', 'user']),
    ...mapGetters(['permission'])
  },
  methods: {
    getApplications (instanceId) {
      return this.applications.filter((a) => a.instanceId === instanceId)
    }
  },
  beforeMount () {
    if (this.permission('accounting')) {
      this.$router.push('/billing')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../theme";

  .flag {
    max-width: 24px;
    display: block;
    cursor: pointer;
  }
  .nothing {
    max-height: 300px;
    padding: 50px 0;
  }
  .el-button--text {
    color: $--button-info-background-color;
    font-weight: 500;

    &:hover, &:focus {
      color: $--color-primary;
    }
  }
  .logo-white {
    //background-color: $--color-primary-alt;
    background-image: url(../assets/logo-icon-white.svg);
    background-repeat: no-repeat;
    background-size: 30px;
    background-position: top 7px left 9px;
    padding-left: 40px;
    font-weight: 500 !important;
  }
  .screen {
    height: 24px;
    width: 36px;
    margin-right: 5px;
    cursor: pointer;
    display: block;
    float: left;
    border: 1px solid $--border-color-base;
    border-radius: 2px;
  }
  .dashboard {
    padding-top: 0;

    .start {
      margin-left: auto !important;
      margin-right: auto !important;
      max-width: 800px;
      padding: 50px;
    }

    .apps {
      border-radius: 20px;
      background-image: url(../assets/hero/nothing-instances.svg);
      background-size: 160px;
      background-position: top 55px right 50px;
      background-repeat: no-repeat;
      padding: 20px;
    }

    .app {
      background-position: center left 16px;
      background-repeat: no-repeat;
      background-size: 25px;
      padding-left: 50px;
    }
  }
</style>

<style lang="scss">
  #instances-list {
    .screen {
      .bundle-image {
        width: 16px;
        margin: 0 auto;
        height: 22px;
      }
    }

    .wrapper.has-tips {
      position: relative;

      .tips {
        margin-left: 0 !important;
        margin-right: 0 !important;
        position: absolute;
        bottom: 0;
        width: 100%;
      }
    }
  }
</style>
